<template>
    <form-row title="Is any Portion Non-Refundable?"
        :no_border="earnest_money_non_refundable_value ? true : false"
        :class="{ 'mt-8': earnest_money_non_refundable_value }"
        label_class="self-start"
    >
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="earnest_money_non_refundable"
                v-model="earnest_money_non_refundable_value"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>

        <div v-if="earnest_money_non_refundable" class="mt-4">
            <div class="flex items-center">
                <div class="flex-none sm:w-36 my-2">
                    <div v-show="earnest_money_non_refundable_by_percent">
                        <input-money
                            :value="earnest_money_non_refundable_by_percent"
                            tabindex="-1"
                            :read_only="true"
                        />
                    </div>

                    <div v-show="! earnest_money_non_refundable_by_percent">
                        <input-money
                            v-model="earnest_money_non_refundable_entered"
                            :read_only="read_only"
                        />
                    </div>

                    <input
                        name="earnest_money_non_refundable_amount"
                        type="hidden"
                        :value="earnest_money_non_refundable_amount"
                        :read_only="true"
                    />
                </div>

                <div class="flex flex-1 items-center my-2">
                    <span class="text-sm text-gray-600 sm:pl-6 pr-6">
                        {{ $t('- OR -') }}
                    </span>

                    <div class="w-1/4 sm:w-1/5">
                        <input-percent
                            name="earnest_money_non_refundable_percent"
                            v-model="earnest_money_non_refundable_percent"
                            :read_only="read_only"
                        />
                    </div>

                    <span class="text-sm text-gray-600 leading-snug pl-4">
                        {{ $t('of') }} {{ total_earnest_money_formatted }} <br>{{ $t('total earnest money') }}
                    </span>
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        earnest_money_non_refundable: {},
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            earnest_money_non_refundable_value:
                this.earnest_money_non_refundable,
            earnest_money_non_refundable_percent:
                this.commercial.earnest_money_non_refundable_percent,
            earnest_money_non_refundable_entered:
                this.commercial.earnest_money_non_refundable_amount,
        }
    },

    computed: {
        total_earnest_money() {
            return this.formatMoney(store.state.total_earnest_money);
        },
        earnest_money_non_refundable_by_percent() {
            return this.earnest_money_non_refundable_percent
                ? this.formatMoney((this.earnest_money_non_refundable_percent / 100) * this.moneyVal(this.total_earnest_money))
                : null;
        },
        earnest_money_non_refundable_amount() {
            return this.earnest_money_non_refundable_by_percent || this.earnest_money_non_refundable_entered;
        },
        total_earnest_money_formatted() {
            return this.total_earnest_money && ! isNaN(this.total_earnest_money)
                ? '$' + this.formatMoneyToString(this.total_earnest_money)
                : '';
        },
    },

    watch: {
        earnest_money_non_refundable_value(val) {
            this.$emit('input', val);
        },
    },
}
</script>
